<template>
  <div v-if="validationState.$dirty">
    <p v-for="param in validationParams" :key="param.name" class="error">
      {{ $t(validationMessage(param)) }}
    </p>
  </div>
</template>
<script>
export default {
  props: {
      validationState: { type: Object, required: true },
    validationMessages: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    validationParams() {
      return this.validationState
        .$flattenParams()
        .filter(param => this.validationState[param.name] === false);
    }
  },
  methods: {
    validationMessage(param) {
      return (
        this.validationMessages[param.name] || "validations_field_" + param.name
      );
    }
  }
};
</script>
